import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { request } from '../../../api/request.tsx';

interface StudentNotificationData {
  title: string;
  titleEn: string;
  titleKo: string;
  description: string;
  descriptionEn: string;
  descriptionKo: string;
  data: {
    navigation: string;
    isEvent: boolean;
    price: number;
    event: string;
    expire_date: string;
  };
}

const StudentNotificationPage = () => {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState<{[key: string]: string}>({});

  const [formData, setFormData] = useState<StudentNotificationData>({
    title: 'NHANH TAY NHẬN NGAY COUPON GIẢM GIÁ 20,000Đ!',
    titleEn: 'COUPON DISCOUNT 20,000 VND!',
    titleKo: '20.000동 할인 쿠폰!',
    description: 'Dành cho các bạn học sinh khi đến chụp ảnh tại PHOTO TIME',
    descriptionEn: 'For students when taking photos at PHOTO TIME',
    descriptionKo: '포토타임에 사진을 찍으러 오시는 학생 고객에게',
    data: {
      navigation: 'phototime://NotificationScreen',
      isEvent: true,
      price: 20000,
      event: 'STUDENT',
      expire_date: ''
    }
  });

  const handleInputChange = (field: string, value: any) => {
    if (field.includes('.')) {
      const [parent, child] = field.split('.');
      setFormData(prev => ({
        ...prev,
        [parent]: {
          ...(prev[parent as keyof StudentNotificationData] as any),
          [child]: value
        }
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [field]: value
      }));
    }
  };

  const validateForm = () => {
    const newErrors: {[key: string]: string} = {};

    if (!formData.title.trim()) {
      newErrors.title = 'Tiêu đề tiếng Việt là bắt buộc';
    }
    if (!formData.titleEn.trim()) {
      newErrors.titleEn = 'Tiêu đề tiếng Anh là bắt buộc';
    }
    if (!formData.titleKo.trim()) {
      newErrors.titleKo = 'Tiêu đề tiếng Hàn là bắt buộc';
    }
    if (!formData.description.trim()) {
      newErrors.description = 'Mô tả tiếng Việt là bắt buộc';
    }
    if (!formData.descriptionEn.trim()) {
      newErrors.descriptionEn = 'Mô tả tiếng Anh là bắt buộc';
    }
    if (!formData.descriptionKo.trim()) {
      newErrors.descriptionKo = 'Mô tả tiếng Hàn là bắt buộc';
    }
    if (!formData.data.navigation.trim()) {
      newErrors['data.navigation'] = 'Navigation là bắt buộc';
    }
    if (formData.data.price <= 0) {
      newErrors['data.price'] = 'Giá trị coupon phải lớn hơn 0';
    }
    if (!formData.data.event.trim()) {
      newErrors['data.event'] = 'Event là bắt buộc';
    }
    if (!formData.data.expire_date.trim()) {
      newErrors['data.expire_date'] = 'Ngày hết hạn là bắt buộc';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!validateForm()) {
      alert('Vui lòng kiểm tra và sửa các lỗi validation trước khi gửi');
      return;
    }
// console.log(formData);

    setLoading(true);
    
    try {
      const response = await request('users/send-noti-student', formData, 'POST');
      
      if (response?.status === true) {
        alert('Gửi thông báo cho học sinh thành công!');
        // Reset form
        setFormData({
          title: 'NHANH TAY NHẬN NGAY COUPON GIẢM GIÁ 20,000Đ!',
          titleEn: 'COUPON DISCOUNT 20,000 VND!',
          titleKo: '20.000동 할인 쿠폰!',
          description: 'Dành cho các bạn học sinh khi đến chụp ảnh tại PHOTO TIME',
          descriptionEn: 'For students when taking photos at PHOTO TIME',
          descriptionKo: '포토타임에 사진을 찍으러 오시는 학생 고객에게',
          data: {
            navigation: 'phototime://NotificationScreen',
            isEvent: true,
            price: 20000,
            event: 'STUDENT',
            expire_date: ''
          }
        });
        setErrors({});
      } else {
        alert(response?.message || 'Có lỗi xảy ra khi gửi thông báo');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Có lỗi xảy ra');
    } finally {
      setLoading(false);
    }
  };

  const classInput = "w-full border-[1px] border-[pink] rounded-md px-3 py-2 outline-none focus:border-pink-500 focus:ring-1 focus:ring-pink-500";
  const classLabel = "font-semibold text-[pink] mb-2 block";
  const classError = "text-red-500 text-sm mt-1";

  return (
    <div className="w-full max-w-4xl mx-auto p-6">
      <div className="text-2xl text-center text-[pink] font-bold mb-8">
        THÔNG BÁO CHO HỌC SINH
      </div>

      <form onSubmit={handleSubmit} className="space-y-8">
        {/* Multi-language Titles */}
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
          <h3 className="text-lg font-bold text-[pink] mb-6">Tiêu đề</h3>
          
          <div className="space-y-4">
            <div>
              <label className={classLabel}>Tiếng Việt*</label>
              <input
                type="text"
                value={formData.title}
                onChange={(e) => handleInputChange('title', e.target.value)}
                className={`${classInput} ${errors.title ? 'border-red-500' : ''}`}
                placeholder="Nhập tiêu đề tiếng Việt"
              />
              {errors.title && <div className={classError}>{errors.title}</div>}
            </div>

            <div>
              <label className={classLabel}>English*</label>
              <input
                type="text"
                value={formData.titleEn}
                onChange={(e) => handleInputChange('titleEn', e.target.value)}
                className={`${classInput} ${errors.titleEn ? 'border-red-500' : ''}`}
                placeholder="Nhập tiêu đề tiếng Anh"
              />
              {errors.titleEn && <div className={classError}>{errors.titleEn}</div>}
            </div>

            <div>
              <label className={classLabel}>한국어*</label>
              <input
                type="text"
                value={formData.titleKo}
                onChange={(e) => handleInputChange('titleKo', e.target.value)}
                className={`${classInput} ${errors.titleKo ? 'border-red-500' : ''}`}
                placeholder="Nhập tiêu đề tiếng Hàn"
              />
              {errors.titleKo && <div className={classError}>{errors.titleKo}</div>}
            </div>
          </div>
        </div>

        {/* Multi-language Descriptions */}
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
          <h3 className="text-lg font-bold text-[pink] mb-6">Mô tả</h3>
          
          <div className="space-y-4">
            <div>
              <label className={classLabel}>Tiếng Việt*</label>
              <textarea
                value={formData.description}
                onChange={(e) => handleInputChange('description', e.target.value)}
                className={`${classInput} min-h-[100px] resize-y ${errors.description ? 'border-red-500' : ''}`}
                placeholder="Nhập mô tả tiếng Việt"
              />
              {errors.description && <div className={classError}>{errors.description}</div>}
            </div>

            <div>
              <label className={classLabel}>English*</label>
              <textarea
                value={formData.descriptionEn}
                onChange={(e) => handleInputChange('descriptionEn', e.target.value)}
                className={`${classInput} min-h-[100px] resize-y ${errors.descriptionEn ? 'border-red-500' : ''}`}
                placeholder="Nhập mô tả tiếng Anh"
              />
              {errors.descriptionEn && <div className={classError}>{errors.descriptionEn}</div>}
            </div>

            <div>
              <label className={classLabel}>한국어*</label>
              <textarea
                value={formData.descriptionKo}
                onChange={(e) => handleInputChange('descriptionKo', e.target.value)}
                className={`${classInput} min-h-[100px] resize-y ${errors.descriptionKo ? 'border-red-500' : ''}`}
                placeholder="Nhập mô tả tiếng Hàn"
              />
              {errors.descriptionKo && <div className={classError}>{errors.descriptionKo}</div>}
            </div>
          </div>
        </div>

        {/* Event Data */}
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
          <h3 className="text-lg font-bold text-[pink] mb-6">Thông tin sự kiện</h3>
          
          <div className="space-y-4">
            <div>
              <label className={classLabel}>Navigation*</label>
              <input
                readOnly
                type="text"
                value={formData.data.navigation}
                onChange={(e) => handleInputChange('data.navigation', e.target.value)}
                className={`${classInput} ${errors['data.navigation'] ? 'border-red-500' : ''} bg-gray-100 text-gray-500 cursor-not-allowed`}
                placeholder="phototime://NotificationScreen"
              />
              {errors['data.navigation'] && <div className={classError}>{errors['data.navigation']}</div>}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className={classLabel}>Giá trị coupon (VND)*</label>
                <input
                readOnly
                  type="number"
                  value={formData.data.price}
                  onChange={(e) => handleInputChange('data.price', parseInt(e.target.value) || 0)}
                  className={`${classInput} ${errors['data.price'] ? 'border-red-500' : ''} bg-gray-100 text-gray-500 cursor-not-allowed`}
                  placeholder="20000"
                  min="0"
                />
                {errors['data.price'] && <div className={classError}>{errors['data.price']}</div>}
              </div>

              <div>
                <label className={classLabel}>Event*</label>
                <input
                  readOnly
                  type="text"
                  value={formData.data.event}
                  onChange={(e) => handleInputChange('data.event', e.target.value)}
                  className={`${classInput} ${errors['data.event'] ? 'border-red-500' : ''} bg-gray-100 text-gray-500 cursor-not-allowed`}
                  placeholder="STUDENT"
                />
                {errors['data.event'] && <div className={classError}>{errors['data.event']}</div>}
              </div>
            </div>

            <div>
              <label className={classLabel}>Ngày hết hạn*</label>
              <input
                type="date"
                value={(() => {
                  if (formData.data.expire_date) {
                    const [day, month, year] = formData.data.expire_date.split('/');
                    if (day && month && year) {
                      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
                    }
                  }
                  return '';
                })()}
                onChange={(e) => {
                  const dateValue = e.target.value;
                  if (dateValue) {
                    const [year, month, day] = dateValue.split('-');
                    const formattedDate = `${day}/${month}/${year}`;
                    handleInputChange('data.expire_date', formattedDate);
                  } else {
                    handleInputChange('data.expire_date', '');
                  }
                }}
                className={`${classInput} ${errors['data.expire_date'] ? 'border-red-500' : ''}`}
              />
              {errors['data.expire_date'] && <div className={classError}>{errors['data.expire_date']}</div>}
            </div>

            <div className="flex items-center space-x-2">
              <input
                type="checkbox"
                id="isEvent"
                checked={formData.data.isEvent}
                onChange={(e) => handleInputChange('data.isEvent', e.target.checked)}
                className="w-4 h-4 text-pink-600 bg-gray-100 border-gray-300 rounded focus:ring-pink-500"
              />
              <label htmlFor="isEvent" className="text-sm font-medium text-gray-700">
                Đây là sự kiện
              </label>
            </div>
          </div>
        </div>

        {/* Submit Button */}
        <div className="flex justify-center">
          <button
            type="submit"
            disabled={loading}
            className="px-8 py-3 bg-[pink] text-white rounded-md hover:bg-pink-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed font-semibold"
          >
            {loading ? 'Đang gửi...' : 'Gửi thông báo cho học sinh'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default StudentNotificationPage;